export default __webpack_public_path__ + "static/media/toTop.6b477902.svg";